import { useMemo, useState, useCallback } from "react";
import { matchesWithWildcard } from "../util/helper/helperFunctions";

const useTableSearch = (data) => {
  const [searchFilters, setSearchFilters] = useState({});

  // unified updateFilter: accepts either (key, value) or an object of filters
  const updateFilter = useCallback((keyOrObj, value) => {
    setSearchFilters((prev) => {
      if (typeof keyOrObj === "object" && keyOrObj !== null) {
        // bulk update case
        return { ...prev, ...keyOrObj };
      }
      // single key-value update
      return { ...prev, [keyOrObj]: value };
    });
  }, []);

  const clearFilters = useCallback(() => {
    setSearchFilters({});
  }, []);

  const isTableSearchFiltersEnabled = useMemo(() => {
    return Object.values(searchFilters).some(
      (value) => value !== undefined && value !== null && value !== ""
    );
  }, [searchFilters]);

  const filteredData = useMemo(() => {
    if (!data?.length) return [];

    if (!isTableSearchFiltersEnabled) return data;

    return data.filter((item) =>
      Object.entries(searchFilters).every(([key, value]) => {
        if (!value) return true;
        const cellValue = String(item[key] ?? "").toLowerCase();
        return matchesWithWildcard(value, cellValue);
      })
    );
  }, [data, searchFilters, isTableSearchFiltersEnabled]);

  return {
    filteredData,
    searchFilters,
    updateFilter,
    clearFilters,
    isTableSearchFiltersEnabled
  };
};

export default useTableSearch;
